import { mapValues } from "lodash";
import { State } from "./types";

const mutations = {};

const n = mapValues(mutations, (_, key) => key);

export { n as mutationNames, mutations };
